import { ColorIconHelper, SocialNetworksAvailables } from '@hub/shared'
import { useMemo } from 'react'
import './social-icon.component.scoped.scss'

interface Props {
  socialNetwork: SocialNetworksAvailables
}

export default ({ socialNetwork }: Props) => {
  const colorIconHelper = useMemo(() => new ColorIconHelper(), [])

  return (
    <span className={`social-icon background-${colorIconHelper.setColor(socialNetwork)}`}>
      <i className={`fa-brands fa-${colorIconHelper.setIcon(socialNetwork)}`}></i>
    </span>
  )
}
